Liferay.Loader.define(
	'frontend-js-node-shims$path@0.0.0/index',
	['module', 'frontend-js-node-shims$path-browserify'],
	function(module, shim) {
		module.exports = shim;
	});